export const enum RelatedContentAnexoEnum {
  INTERMEDIARIA = 'INTERMEDIARIA',
  BIBLIOTECA = 'BIBLIOTECA',
  UNKNOWN = 'UNKNOWN'
}
